import { mapMutations } from 'vuex';
import { SPECIAL_HEADER, setAuthorization } from '@/utils/request';
import verificationCodeImg from '@/mixin/verification-code-img';
import { rqtPostUserLoginInfo, rqtGetUserWorkwechatLogin, rqtGetUserCheckToken } from '@/services/common';
import { ls } from '@/utils/aes';
import PageNavLayoutCpt from '@/components/page/PageNavLayoutCpt';
export default {
  mixins: [verificationCodeImg],
  components: {
    PageNavLayoutCpt
  },
  data() {
    return {
      userCode: '',
      password: '',
      validateCode: '',
      logging: false,
      isShowPage: false
    };
  },
  created() {
    let code = this.$route.query && this.$route.query.code;
    let state = this.$route.query && this.$route.query.state;
    if (!code) {
      const params = new URLSearchParams(window.location.search);
      code = params.get('code');
      state = params.get('state');
    }
    // state=1000008 企业微信财富核心
    if (code && state == 1000008) {
      rqtGetUserCheckToken().then(() => {
        this.$router.replace('/work-wx/main');
      }).catch(() => {
        rqtGetUserWorkwechatLogin({
          code
        }).then(res => {
          this.afterLogin(res);
        }).catch(() => {});
      });
    } else {
      this.isShowPage = true;
    }
  },
  mounted() {
    this.handleCodeImg();
  },
  methods: {
    ...mapMutations('account', ['setUser', 'setPermissions', 'setRoles']),
    onSubmit(values) {
      if (values) {
        this.logging = true;
        rqtPostUserLoginInfo({
          userCode: this.userCode,
          password: this.password,
          validateCode: this.validateCode,
          belongSystem: 'client-wms',
          uuid_key: this.codeUuidKey
        }).then(this.afterLogin).catch(() => {
          this.logging = false;
        });
      }
    },
    afterLogin(res) {
      this.logging = false;
      const loginRes = res.data;
      if (loginRes.code === 1000) {
        // refactor res
        const user = {
          name: 'Admin',
          avatar: '',
          address: '浙江省杭州市西湖区',
          position: '公元大厦'
        };
        const {
          [SPECIAL_HEADER.xsrfHeaderName.toLowerCase()]: accesstoken,
          [SPECIAL_HEADER.refreshToken.toLowerCase()]: refreshtoken
        } = res.headers;
        user.name = loginRes.data.agentName || loginRes.data.userName;
        user.refreshtoken = refreshtoken;
        user.userId = loginRes.data.userId;
        user.branchId = loginRes.data.branchId;
        user.branchName = loginRes.data.branchName;
        user.departmentId = loginRes.data.departmentId;
        user.agentId = loginRes.data.agentId;
        // user.isSetPwd = 'N'
        ls.set('pubkey', res.headers[SPECIAL_HEADER.publicKey.toLowerCase()]);
        if (user.branchName) {
          user.name = user.branchName + '-' + user.name;
        }
        const expireAt = new Date(new Date().getTime() + 4 * 60 * 60 * 1000);
        this.setUser(user);
        setAuthorization({
          token: accesstoken,
          expireAt: new Date(expireAt)
        });
        // init router by fetch
        // const { menuRouter, permissions } = this.initRoutesConfig(loginRes.data.privilegeMap)
        // this.setPermissions(permissions)
        // loadRoutes(menuRouter)
        this.$router.replace('/work-wx/main');
      } else {
        this.error = loginRes.msg;
      }
    }
  }
};